import zgmCodeList from "@/router/pages/admin/zgmCodeAgent/zgm";

const zgmCodeAgent = {
    path: '/zgmCodeAgent',
    component: resolve => require(['@/pages/admin/zgmCodeAgent'], resolve),
    redirect: '/zgmCodeAgent/zgm',
    children: [
        zgmCodeList
    ],
    meta: {
        requireAuth: true
    },
}
export default zgmCodeAgent